import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useTimesheetFlow } from "@/features/timesheetFlow/useTimesheetFlow";
import { useProjectOverview } from "@/projectOverview/useProjectOverview";

export function isMaterialAnforderungPath(pathname: string): boolean {
  const path = (pathname || "/").replace(/\/+$/, "") || "/";
  return (
    path === "/materialanforderungen" ||
    path.startsWith("/bestellwesen/materialanforderungen")
  );
}

/**
 * Öffnet die Projektübersicht bei `?auftrag_id=` und entfernt den Parameter danach.
 * Schließt einen offenen Stundennachweis (höherer z-Index), damit die Übersicht sichtbar bleibt.
 *
 * Muss innerhalb von TimesheetFlowProvider laufen (z. B. ProjectOverviewDialogMount).
 * Auf der Materialanforderungs-Seite nicht greifen: dort bedeutet der Parameter
 * (bzw. ältere QR-Links) „neue MA zu diesem Auftrag“.
 */
export function useProjectOverviewDeepLink() {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const { open } = useProjectOverview();
  const { close: closeTimesheet } = useTimesheetFlow();

  useEffect(() => {
    if (isMaterialAnforderungPath(location.pathname)) return;
    if (searchParams.get("create_auftrag_id")) return;

    const raw = searchParams.get("auftrag_id");
    if (!raw) return;
    const id = Number(raw);
    if (!Number.isFinite(id) || id <= 0) return;

    closeTimesheet();
    open(id);
    const next = new URLSearchParams(searchParams);
    next.delete("auftrag_id");
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams, location.pathname, open, closeTimesheet]);
}
